import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { SignatureCapture, type SignatureCaptureHandle } from '../../../components/userSignature/SignatureCapture';

export type SamplePreservationSignaturePadHandle = {
  exportPng: () => string | null;
  hasStroke: () => boolean;
};

type Props = {
  open: boolean;
  disabled?: boolean;
  title?: string;
  helperText?: string;
  canvasTestId?: string;
  onStrokeChange?: (hasStroke: boolean) => void;
};

export const SamplePreservationSignaturePad = forwardRef<SamplePreservationSignaturePadHandle, Props>(
  function SamplePreservationSignaturePad(
    {
      open,
      disabled = false,
      title = 'Tanda tangan',
      helperText = 'Gambar tanda tangan di kotak di bawah.',
      canvasTestId = 'sample-preservation-sign-canvas',
      onStrokeChange,
    },
    ref,
  ) {
    const innerRef = useRef<SignatureCaptureHandle | null>(null);

    useImperativeHandle(ref, () => ({
      exportPng: () => innerRef.current?.exportPng() ?? null,
      hasStroke: () => innerRef.current?.isReady() ?? false,
    }));

    return (
      <SignatureCapture
        ref={innerRef}
        open={open}
        disabled={disabled}
        title={title}
        helperText={helperText}
        canvasTestId={canvasTestId}
        allowDefault
        onReadyChange={onStrokeChange}
      />
    );
  },
);
